import { useEffect, useState } from 'react';
import { getFocusMode, setFocusMode } from '@util/focusModeController';

const useLocalFocusModeToggle = (defaultFocusMode = false, onEnable, onDisable) => {
    const [isFocusMode, setIsFocusMode] = useState(defaultFocusMode);

    const handleDisableFocusMode = () => {
        setFocusMode(false);
        setIsFocusMode(false);
    };

    const handleEnableFocusMode = () => {
        setFocusMode(true);
        setIsFocusMode(true);
    };

    const handleToggleFocusMode = () => {
        if (isFocusMode) {
            if (typeof onDisable === 'function') {
                onDisable();
            }
            handleDisableFocusMode();
        } else {
            if (typeof onEnable === 'function') {
                onEnable();
            }
            handleEnableFocusMode();
        }
    };

    useEffect(() => {
        setIsFocusMode(defaultFocusMode);
        if (defaultFocusMode) {
            handleEnableFocusMode();
        } else {
            handleDisableFocusMode();
        }
    }, [defaultFocusMode]);

    useEffect(
        () => {
            const handleStorageChange = (e) => {
                if (e.key === 'inactivityTimer') {
                    setIsFocusMode(getFocusMode());
                }
            };

            window.addEventListener('storage', handleStorageChange);

            return () => {
                window.removeEventListener('storage', handleStorageChange);
            };
        },
        // eslint-disable-next-line
        [],
    );

    return {
        isFocusMode,
        onToggleFocusMode: handleToggleFocusMode,
        onDisableFocusMode: handleDisableFocusMode,
        onEnableFocusMode: handleEnableFocusMode,
    };
};

export default useLocalFocusModeToggle;
